export default "__VITE_ASSET__D4P9y0hT__"